import { decode as base64_decode, encode as base64_encode } from 'base-64';
import RootStore from './RootStore';
import { postApi, baseURL } from '../components/Utility'
import {
    action,

    makeObservable,
    observable,

} from 'mobx';


class DriverExpenseReportStore {
    expenseReport = []
    total = 0
    loading = false
    rootStore
    rec = 0

    constructor(rootStore) {
        makeObservable(this, {
            expenseReport: observable,
            total: observable,
            loading: observable,
            rec: observable,
            loadData: action,
            exportExcel: action,

            exportpdf: action,

        });
        this.rootStore = rootStore;

    }

    async loadData({ offset, limit, companyId, fromDate, toDate, driverId }) {
        console.log("userId", driverId)
        this.loading = true
        var postData = { "companyId": companyId, "driverId": driverId, "fromDate": fromDate, "toDate": toDate, "offset": offset, "limit": limit, "page": 1 }
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi.getClient().post("index.php?c=driver&a=expenseReport", "postData=" + base64Input);
        console.log("expenseReport ", response?.data?.data)

        this.expenseReport = response?.data?.data?.expancelist
        if (this.expenseReport.length > 0) {
            this.rec = 1
        }
        this.total = parseInt(response?.data?.data?.TotalCount);
        this.loading = false;
    }
    async exportExcel(getDta) {
        window.location.href = baseURL + "index.php?c=driver&a=exportexpenseReportexcel&cid=" + getDta.companyId + '&fD=' + getDta.fromDate + '&tD=' + getDta.toDate + '&dId=' + getDta.driverId + '&colList=' + getDta.colList

    }
    async exportpdf(getDta) {
        window.location.href = baseURL + "index.php?c=driver&a=exportexpenseReportpdf&cid=" + getDta.companyId + '&fD=' + getDta.fromDate + '&tD=' + getDta.toDate + '&dId=' + getDta.driverId + '&colList=' + getDta.colList

    }


}

export default DriverExpenseReportStore;
